import FieldConfig from "../../../proto/field-config"
import {
    ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan,
    ConditionType_NumberLessThan
} from "../../../../model2/conditions/condition-types"
import FieldNumber from "../../../generic/number/number"

// const debug = "FieldExpenseUnits"
const debug = false

export default class FieldExpenseUnits extends FieldNumber {

    constructor(config:FieldConfig) {
        super(config)

        this.positiveOnly = true

        this.conditionTypes     = [
            ConditionType_NumberGreaterThan,
            ConditionType_NumberLessThan,
            ConditionType_NumberEquals
        ]
    }

    isValueValid(value: any): boolean {
        const numberValue = parseFloat(value)

        // value can't be empty
        if (_.isNil(numberValue) || numberValue === 0) {
            return false
        }

        return super.isValueValid(numberValue)
    }
}
